// extracted by mini-css-extract-plugin
export var phone = "_4r-0";
export var phoneDragging = "_4r-1";